

export const userInfo = s => s.userInfo;

// 用户类型 - 超管，企管，普通用户
export const USER_TYPES = () => ({ SUPER_MANAGER: 0, ENTERPRISE_MANAGER: 1, ORDINARY_USER: 2 });

export const userType = s => s.userInfo && s.userInfo.type;

// 用户名
export const userName = s => s.userInfo && s.userInfo.display_name;

// 用户ID
export const userID = s => s.userInfo && s.userInfo.id;

// 企业ID
export const enterpriseID = s => s.enterpriseID;

// 企业信息列表
export const enterpriseInfoList = s => s.enterpriseInfoList;

// 组织ID
export const orgID = s => s.orgID;

// 当前用户所有组织列表
export const allProducts = s => s.allProducts;

// 当前用户所选组织能看到的产品列表的IDs
export const privProductIDs = s => s.privProductIDs;

export const privProducts = s => s.privProducts;

export const orgAllList = s => s.orgAllList;

// 许可证信息
export const licenseInfo = s => s.licenseInfo;

// 多语言
export const showLanguage = s => s.showLanguage;

// 机器人列表
export const robotList = (s) => {
  const ret = [];
  Object.keys(s.robotList).forEach((key) => {
    ret.push({
      id: key,
      name: s.robotList[key].name || '',
      description: s.robotList[key].description || '',
      languageId: s.robotList[key].props ? s.robotList[key].props[0].id : '',
      languageName: s.robotList[key].props ? s.robotList[key].props[0].p_name : '',
      model: s.robotList[key].props && s.robotList[key].props[1] ? s.robotList[key].props[1].id : '',
      type: s.robotList[key].robot_type || '',
      // cardTags: s.robotList[key].latest_audit_log ?
      // [s.robotList[key].latest_audit_log.user_id,
      // s.robotList[key].latest_audit_log.content] : [],
      cardTags: [`${window.vm.$t('general.audit_time')}: ${s.robotList[key].latest_audit_log ? s.robotList[key].latest_audit_log.create_time.split('.')[0] : ''}`],
      tagTooltips: [`${window.vm.$t('general.access_time')}: ${s.robotList[key].access_time ? s.robotList[key].access_time.split('.')[0] : ''}`],
    });
  });
  return ret;
};

export const privilegeList = s => s.privilegeList;



// WEBPACK FOOTER //
// ./src/store/getter.js